
"use strict"; // jshint ignore:line

import ActStack               from '../classes/ActStack.js';
import { ObjectSolverByUuid } from '../services/ObjectSolverService.js';

export default function UserActionHistoryService( $rootScope,  Notification,  gettextCatalog ) {

	UserActionHistoryService.getInstance = () => this;

	var actStack = window.actStack = $rootScope.actStack = this;

	var toWrapFns = {
		do      : actStack.do,
		addUndo : actStack.addUndo,
		doUndo  : actStack.doUndo,
		addRedo : actStack.addRedo,
		doRedo  : actStack.doRedo
	};

	Object.keys( toWrapFns ).forEach(function( key ) {

		var userActEvent_key = key[0].toUpperCase() + key.substr( 1 );
		var onBeforeUserAct_key1 = "onBeforeUserAct" + userActEvent_key;
		var onAfterUserAct_key1  = "onAfterUserAct"  + userActEvent_key;

		var onBeforeUserAct_key2, onAfterUserAct_key2;

		if (key[0] + key[1] == "do") {
			onBeforeUserAct_key2 = "onBeforeUserAct";
			onAfterUserAct_key2  = "onAfterUserAct";
		}
	

		actStack[ key ] = function() {
			console.count( "userActionHistoryService." + key + "()" );

			$rootScope.$broadcast( onBeforeUserAct_key1, null );

			if (onBeforeUserAct_key2) $rootScope.$broadcast( onBeforeUserAct_key2, null );

			var result;

			try {
				result = toWrapFns[ key ].apply( actStack, arguments );
			} catch (error) {
				try {
					var message = gettextCatalog.getStringIfExists( "Failed to " + key + " " + arguments[ 0 ] );
					if (message) Notification.error( message );
				} catch (e) { console.error( e ); }

				throw error;
			}

			$rootScope.$broadcast( onAfterUserAct_key1, null, result );

			if (onAfterUserAct_key2) $rootScope.$broadcast( onAfterUserAct_key2, null, result );

			return result;
		};

	});

	/**************/

	ActStack.call( this, {

		"Object.valueChange": (function( setFn ){
			return {
				"do": function( uuid, type, target, value, prev_value ) {

					var real_prev_value = setFn( uuid, type, target, value );

					prev_value = arguments.length == 5 ? prev_value : real_prev_value;

					if (value != prev_value) {
						actStack.addUndo( "Object.valueChange", {
							uuid       : uuid,
							type       : type,
							target     : target,
							prev_value : prev_value,
							new_value  : value
						});
					}
				},
				"undo": function( act ) {
					setFn( act.uuid, act.type, act.target, act.prev_value );
				},
				"redo": function( act ) {
					setFn( act.uuid, act.type, act.target, act.new_value );
				}
			};
		})(function( uuid, type, key, value ){
			var obj = ObjectSolverByUuid( uuid, type );
	
			if (!obj) throw "Unable to solve object";
	
			var prev_value = obj[key];

			obj[key] = value;

			return prev_value;
		}),

		"arrangement.addOeuvre": {
		},
		"arrangement.rmOeuvre": {
		},

		"helpers.changeHelperLine_startBtm": {
			"do": function( val ){
				if( arguments.length == 0 ) val = !helpers.opts.oeuvreBottomLine_startBtm;
				actStack.addUndo("helpers.changeHelperLine_startBtm", {
					old: !!helpers.opts.oeuvreBottomLine_startBtm,
					cur: helpers.opts.oeuvreBottomLine_startBtm = !!val
				});
				helpers.refreshOeuvreHelper( true );
			},
			"undo": function( act ){ helpers.opts.oeuvreBottomLine_startBtm = !!act.old; },
			"redo": function( act ){ helpers.opts.oeuvreBottomLine_startBtm = !!act.cur; },
			"$postCallback": function(){ helpers.refreshOeuvreHelper( true ); }
		},

		"helpers.oeuvreHorizontalLines.startCtr": {
			"do": function( val ){
				if( arguments.length == 0 ) val = !helpers.opts.oeuvreHorizontalLines.startCtr;
				actStack.addUndo("helpers.oeuvreHorizontalLines.startCtr", {
					old: !!helpers.opts.oeuvreHorizontalLines.startCtr,
					cur: helpers.opts.oeuvreHorizontalLines.startCtr = !!val
				});
				helpers.refreshOeuvreHelper( true );
			},
			"undo": function( act ){ helpers.opts.oeuvreHorizontalLines.startCtr = !!act.old; },
			"redo": function( act ){ helpers.opts.oeuvreHorizontalLines.startCtr = !!act.cur; },
			"$postCallback": function(){ helpers.refreshOeuvreHelper( true ); }
		}
	});
}


UserActionHistoryService.prototype = Object.create( ActStack.prototype );

UserActionHistoryService.$inject = [ "$rootScope","Notification","gettextCatalog" ];


export { UserActionHistoryService }